<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="navigation-wrapper height-350">
                            <div class="keen-slider keen-slider--vertical" #sliderRef>
                              <div class="keen-slider__slide number-slide1">1</div>
                              <div class="keen-slider__slide number-slide2">2</div>
                              <div class="keen-slider__slide number-slide3">3</div>
                              <div class="keen-slider__slide number-slide4">4</div>
                              <div class="keen-slider__slide number-slide5">5</div>
                              <div class="keen-slider__slide number-slide6">6</div>
                            </div>
                            <svg
                              [ngClass]="
                                'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')
                              "
                              (click)="slider.prev()"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
                              />
                            </svg>
                            <svg
                              *ngIf="slider"
                              [ngClass]="
                                'arrow arrow--right ' +
                                (slider.track.details.slides.length - 1 === currentSlide
                                  ? 'arrow--disabled'
                                  : '')
                              "
                              (click)="slider.next()"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
                            </svg>
                        </div>
                        <!-- <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div> -->
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg"> 
                                    <img style="aspect-ratio: 1 / 1;" *ngIf="this.student.img != null" [src]="this.baseService.appUrl + this.student.img" onerror="this.onerror=null;this.src='../../../assets/images/team/avatar.jpg';" alt="Instructor">
                                    <img style="aspect-ratio: 1 / 1;" *ngIf="this.student.img === null" src="../../../assets/images/team/avatar.jpg" alt="Student">
                                
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="row g-5">
                        <div class="col-lg-3">
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudProfile(this.studentId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewStudCourses(this.studentId)"><i class="feather-monitor"></i><span>{{'MyCourses' | translate}}</span></a></li>
                                                    <!-- <li><a (click)="viewWishlist(this.studentId)"><i class="feather-heart"></i><span>{{'fav' | translate}}</span></a></li> -->
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewStudSettings(this.studentId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">

                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">{{'Courses' | translate}}
                                        </h4>
                                    </div>

                                    <div class="row g-5">
                                        <div class="col-lg-4 col-md-6 col-12" *ngFor="let course of enrolledCourses | paginate: { itemsPerPage: 6, currentPage: p }" style="position: relative;">
                                            <div class="rbt-card variation-01 rbt-hover studCourseCard" style="cursor: pointer;">
                                                <div class="rbt-card-img">
                                                    <a>
                                                        <img  style="max-height: 160px !important;min-height: 160px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                                                    </a>
                                                </div>
                                                <div class="rbt-card-body">
                                                    <div class="rbt-card-top">
                                                    </div>
                                                    <h5 class="rbt-card-title" style="font-size: 20px;"><a (click)="viewCourseDetails(course.id)">{{course.courseNameAr}}</a>
                                                    </h5>
                                                    <ul class="rbt-meta">
                                                        <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                                        <li>{{course.studentsNo}} {{'Students' | translate}}</li>
                                                    </ul>

                                                    <div class="rbt-card-bottom">
                                                        <div class="rbt-price" *ngIf="course.price === 0">
                                                            <span class="current-price">{{'Free' | translate}}</span>
                                                        </div>
                                                        <div class="rbt-price" *ngIf="course.price > course.offerPrice">
                                                            <span class="current-price">{{course.offerPrice}} {{'SAR' | translate}}</span>
                                                            <span class="off-price">{{course.price}} {{'SAR' | translate}}</span>
                                                        </div>
                                                        <div class="rbt-price" *ngIf="course.offerPrice > course.price">
                                                            <span class="current-price">{{course.price}} {{'SAR' | translate}}</span>
                                                        </div>
                                                        <a class="rbt-btn-link" *ngIf="course.isPayed !== false" (click)="watchCourse(course.id, course.startDate)"><i class="feather-monitor"></i>{{'attend' | translate}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="studCourseCardOverlay" *ngIf="course.isPayed === false">
                                                <div class="contact-btn mt--30">
                                                    <a class="rbt-btn hover-transform-none btn-border-gradient radius-round" style="cursor: default;">
                                                        <div class="icon-reverse-wrapper">
                                                            <span class="btn-text">{{'waitingForConfirmation' | translate}}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12 mt--60">
                                            <pagination-controls 
                                            class="rbt-pagination" 
                                            (pageChange)="p = $event"
                                            previousLabel=""
                                            nextLabel=""
                                            ></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
